import { type NavigationTreeDataDTO } from "~/Notifications/api/getNavigationTree";

import classes from "./NotificationSettings.module.less";
import { OnOffSwitch } from "~/Notifications/NotificationSettingsPage/OnOffSwitch";
import { NotificationSettingsConfirmationPopup } from "~/Notifications/NotificationSettingsPage/NotificationSettingsConfirmationPopup";
import { requestConfirmation } from "~/AddToCart/ModalSevice";
import { useTranslation } from "react-i18next";

interface Props {
  onToggle: (isParent: boolean, type: string, newValue: boolean) => void;
  data: NavigationTreeDataDTO[];
}
export const NotificationSettings = ({ onToggle, data }: Props) => {
  const { t } = useTranslation();

  const onToggleParent = async (newVal: boolean, parentType: string) => {
    if (parentType === "ALL" && !newVal) {
      // Turning off all notifications
      const confirmed = await requestConfirmation((props) => <NotificationSettingsConfirmationPopup {...props} />);
      if (!confirmed) {
        return;
      }
    }
    onToggle(true, parentType, newVal);
  };

  return (
    <div className={classes.container}>
      {data.map((item, i) => (
        <div key={item.parentType} className={classes.singleCategoryContainer} id={item.parentType}>
          <div className={classes.categoryCell}>
            <h4 className={classes.categoryCellTitle}>{t(`${item.parentTypeTranslation}`)}</h4>
            <OnOffSwitch
              selected={item.enabledParent}
              onToggle={(newVal) => onToggleParent(newVal, item.parentType)}
              switchTestId={`toggle-notification-${i}`}
            />
          </div>
          {item.childTypes?.map((childItem) => (
            <div key={childItem.type} className={classes.itemCell}>
              <h5>{t(childItem.typeTranslation)}</h5>
              <OnOffSwitch
                selected={childItem.enabled}
                onToggle={(newVal) => onToggle(false, childItem.type, newVal)}
                switchTestId={`toggle-notification-${i}`}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
